import { MouseEventHandler } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { openMsgModal } from "../../store/MessageModalSlice";
import { logClickEvent } from "../../utils/NativeWebView";

const ChatBotOverlay = () => {

  const dispatch = useAppDispatch();

  const { chatIsOpen } = useAppSelector(state => state.chatBot);
  const { modalChat } = useAppSelector(state => state.webSettings);

  const handleClickChatButton: MouseEventHandler<HTMLDivElement> = e => {
    // e.persist();
    e.stopPropagation();
    logClickEvent('btn_footer', 'click_chatbot', 'message', 'btn_footer');
    dispatch(openMsgModal(modalChat));
  };

  if (!chatIsOpen) return null;

  return (
    <div
      onClick={handleClickChatButton}
      className="fixed right-3 bottom-1 w-32 h-24 z-1000"
    />
  );
};

export default ChatBotOverlay;
